// eslint-disable-next-line no-unused-vars
import api from './api'
import meta from './modules/meta'
import standard from './modules/standard'
import { cleanOutHTML } from '../lib/misc'

export default (resource) => {
  return {
    namespaced: true,
    modules: {
      meta: meta(),
      standard: standard(resource),
    },
    state: {},
    getters: {
      getContentByParentId: (_, getters) => (id) => {
        const content = getters.getArray.find((c) => c.parent_id === id)
        content.data = cleanOutHTML(content.data)
        return content
      },
    },
    mutations: {},
    actions: {},
  }
}
